import { useDialog } from "@/ui-plus/dialog/use-dialog";
import OrderDialog from "./OrderDialog.vue";
import type { ResType } from "@api-client/typeUtils";
import { storeOrdersApiClient } from "@api-client/store_orders";

const ApiPath = storeOrdersApiClient[":storeId"].get_by_order_ids.$post;
type OrderType = ResType<typeof ApiPath>["data"];

const dialog = useDialog();

export const showOrderDialog = (order: OrderType[number]) => {
    dialog.show({
        id: `order-dialog-${order.storeOrderId}`,
        title: `Order #${order.shortOtp}`,
        dialogContentClass: 'max-w-xl',
        closeable: true,
        component: OrderDialog,
        props: {
            storeOrderId: order.storeOrderId,
        },
        // onSuccess: () => {
        //     console.log("OrderDialog success");
        // },
        // onCancel: () => {
        //     console.log("OrderDialog cancel");
        // },
        // onError: (error) => {
        //     console.log("OrderDialog error", error);
        // }
    });
};